import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ActionSheetController } from '@ionic/angular';
import { AuthConstants } from 'src/app/config/auth-constants'
import { AlertController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from '../../services/toast.service';

declare var Razorpay: any;

@Component({
  selector: 'app-spot-wallet',
  templateUrl: './spot-wallet.page.html',
  styleUrls: ['./spot-wallet.page.scss'],
})
export class SpotWalletPage implements OnInit {

  userId: any=localStorage.getItem('userId');
  spotCoins:any;
  spotCash: any;
  orderCount: any;
  referralTierLevel: any;
  giftNo: any;
  flag : any;
  amount: any;
  email1: any;
  phone: any;
  name: any;
  result: any;
  superCoins: any;
  

  constructor(private userService : UserService,private routerActivate: ActivatedRoute,  private router: Router, private authService: StoreService, 
    private toast: ToastService,
    public alertController: AlertController, private navController : NavController) { }
  ngOnInit() {
    
  }

  ionViewDidEnter(){
    let a= {
      uid : this.userService.uid
    }
      this.userService.getUserDetails(a).subscribe((res: any)=>{
        console.log("getUserDetails ", res);
    this.spotCoins=res.spotCoins;
    this.spotCash=res.spotCash;
    console.log("spotcash",this.spotCash)
      // this.getReward();
      this.getconsumerTier();
      })
  }
 

 

  getconsumerTier(){
    let promoListobj={
      consumerId:this.userId
    }
   
   this.authService.cunsumerTier(promoListobj) 
   .subscribe((result: any) => {
     this.orderCount = result.orderCount;
     this.referralTierLevel = result.referralTierLevel;
     console.log("get response from consumerTier",result);
     //this.loadCartItems()
     }, (error: any) => {    
  }); 
  }

  
 getReward(){
  let promoListobj={
    userId:this.userId
  }
 
 this.authService.reward(promoListobj) 
 .subscribe((result: any) => {
   this.spotCash = result.spotCash;
   this.superCoins = result.spotCoins;
   console.log("get rewards",promoListobj);
  
   }, (error: any) => {    
}); 
 }

 
 redeemMethod(){
  let promoListobj={
    userId:this.userId,
    spotCoins:this.superCoins
  }
 
 this.authService.redeem(promoListobj) 
 .subscribe((result: any) => {
  
   console.log("get rewards",promoListobj);
   this.getReward();

  
   }, (error: any) => {    
}); 
 }
 refer()
 {
  this.router.navigate(['/invite'])
 }
 goBack(){
  
  this.navController.navigateForward(['/account']);
  
  
 }

 

 async AddController(){
  const actionSheet = await this.alertController.create({
    header: 'Gift Card',
    cssClass: 'action-search-custom-class',
    inputs: [{
      name: 'Giftcard',
      placeholder: 'Gift Card Number',
      },
     ],
     buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
        handler: (blah) => {

          //  console.log('Confirm Cancel: blah');
        }
      }, {
        text: 'Add',
        handler: (data) => {
          this.giftNo=data.Giftcard;
          if (!this.giftNo) {
           this.toast.presentToast("Please enter valid Gift card No")
             return false;
          }
          this.AddGiftCard();
        }
      }
    ]
  });
  await actionSheet.present();

  const { role } = await actionSheet.onDidDismiss();
}

AddGiftCard(){
  let promoListobj={
    userId:this.userId,
    giftCard:this.giftNo
  }
 // this.authService.addCartServices(APIS.addTocart,formdata,true)
 this.authService.redeemGift(promoListobj) 
 .subscribe((result: any) => {
  
   console.log("get gift points",promoListobj);
   this.getReward();

   //this.loadCartItems()
   }, (error: any) => {    
}); 
}
getGiftCards(){
  this.router.navigate(['/spot-gift-card'])
}
addMoney(){
    let that = this;
    this.userService.currentUser.subscribe((userId: any) => {
      if (this.amount>0) {
        let formData = {
          amount: this.amount,
          userId: userId
        }
        this.authService.addMoneyRazorPay(formData).subscribe((res:any) => {
  
          // this.loader.dismiss();
          console.log(res)
          this.result = res;
          var options = { 
            description: 'SpotYourDeal.com',
            image: '',
            currency: 'INR',
            key: AuthConstants.RazorPay,
  
            order_id: this.result.id,
            //name:this.productObj.name,
            name: "",
            // prefill: {
            //   email: this.email1,
            //   contact: this.phone,
            //   name: this.name
            // },
            theme: {
              color: '#F37254'
            },
            modal: {
              ondismiss: function () {
                alert('dismissed')
              }
            }
          }
          // console.log(options.amount,"heelo hi")
          var successCallback = function (success) {
            console.log("Success payment ID", success)
            var razorpay_payment_id = success.razorpay_payment_id
            var razorpay_order_id = success.razorpay_order_id
            var razorpay_signature = success.razorpay_signature
            let formData = {
              razorpay_payment_id,
              razorpay_order_id,
              razorpay_signature,
              amount: that.amount,
              userId: userId
            }
            localStorage.setItem('razorPy',formData.razorpay_order_id)
            localStorage.setItem('razorPy1',formData.razorpay_payment_id)
            that.userService.verifyAddMoney(formData).subscribe((verifyResp: any) => {
              localStorage.setItem("verify",verifyResp)
              that.userService.updateLogData(res.id, { verifyPaymentResp: JSON.parse(JSON.stringify(verifyResp)) })
  
              var data = verifyResp;
              if (data.razorpay_signature_verified == true) {
                that.spotCash = that.spotCash + that.amount;
                console.log("success")
                that.toast.presentToast("Amount has been added successfully")
                that.router.navigate(['/'])
                console.log("this.spotcash",this.spotCash)
                that.navController.navigateRoot('/order-confirm');
                that.router.navigate(['/spot-wallet'])
              } else {
                that.toast.presentToast("payment failed")
              }
            }, err => {
              localStorage.setItem('error',JSON.stringify(err))
              that.userService.updateLogData(res.id, { verifyPaymentError: JSON.parse(JSON.stringify(err)) })
            })
  
          };
          var cancelCallback = function (error) {
            this.userService.updateLogData(res.id, { cancelCallback: JSON.parse(JSON.stringify(error)) })
            alert(error.description);
            console.log("cancel")
          };
          var rz1=new Razorpay(options, successCallback, cancelCallback)
          rz1.open()
          // RazorpayCheckout.on('payment.success', successCallback)
          // RazorpayCheckout.on('payment.cancel', cancelCallback)
          // RazorpayCheckout.open(options);
        }, error => {
        this.toast.presentToast("error")

          // this.toast.presentToast(error.msg)
        })
      } else {
        this.toast.presentToast("Please enter amount")
      }
    })
}
home(){
  this.router.navigate(['/'])
}
}

